type Args = {
  localStorageKey?: 'mugen.debug.useEffect' | 'mugen.debug.layout';
};

export function debugClient({ localStorageKey }: Args) {
  if (process.env.NEXT_PUBLIC_IS_DEBUGGING_ENABLED !== 'true') {
    return;
  }

  // localStorage can be null or undefined (e.g. Android WebView defaults to null), so access it optionally
  if (typeof window !== 'undefined' && localStorageKey && window.localStorage?.getItem(localStorageKey) === 'true') {
    console.error(`debugClient forcing an error for key '${localStorageKey}'`);
    throw new Error(`debug:${localStorageKey}`);
  }
}
